import { UserManager, WebStorageStateStore } from 'oidc-client';

const url = window.location.origin;
const clientId = window?.env?.OIDC_CLIENT_ID ?? 'atfm-client';

const config = {
  redirect_uri: url + '/oauth/callback',
  silent_redirect_uri: url + '/oauth/callback',
  post_logout_redirect_uri: url,
  client_id: clientId,
  response_type: 'code',
  scope: 'openid',
  loadUserInfo: false,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

let userManager = null;

function createUserManager(cfg) {
  const mgr = new UserManager(cfg);

  mgr.events.addUserLoaded(displayUser);
  mgr.events.addUserSignedIn(displayUser);
  mgr.events.addSilentRenewError(err => console.error('Error while trying to renew access token.', err));
  mgr.events.addAccessTokenExpired(async () => await mgr.signinRedirect());
  return mgr;
}

async function retrieveUser() {
  if (userManager === null) {
    throw new Error('User manager is not ready !');
  }
  const existingUser = await userManager.getUser();
  if (existingUser !== null && !existingUser.expired) {
    return existingUser;
  }
  if (window.location.href.indexOf('state') !== -1) {
    const user = await userManager.signinCallback();
    console.log('Cleaning up URL state');
    return user;
  }
  await userManager.signinRedirect();
  return await userManager.getUser();
}

const ensureTokenValidity = (callback) => {
  retrieveUser()
    .then(user => {
      if (user) {
        displayUser(user);
        callback(user.access_token, user);
      } else {
        callback(null, null);
      }
    }).catch(e => console.error(e));
};

userManager = createUserManager({ ...config, authority: 'https://idp.aos.ams.thalesdigital.io/auth/realms/AOS' });

function displayUser(user) {
  console.log('User info:', user);
}

function logout() {
  userManager.signoutRedirect()
}

export { logout, ensureTokenValidity };